import type { ReactNode } from 'react';
import { ActionIcon, Text, Tooltip } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

import classes from './side-panel.module.css';

export function SidePanel({
    title,
    closeLabel,
    onClose,
    children,
}: Readonly<{ title: string; closeLabel: string; onClose: () => void; children: ReactNode }>) {
    return (
        <aside aria-label={title} className={classes.panel}>
            <div className={classes.header}>
                <Text className={classes.title} fw={500} size="sm">
                    {title}
                </Text>
                <Tooltip label={closeLabel}>
                    <ActionIcon
                        aria-label={closeLabel}
                        className={classes.close}
                        radius="var(--radius-rounded-full)"
                        variant="default"
                        onClick={onClose}
                    >
                        <IconX size={20} />
                    </ActionIcon>
                </Tooltip>
            </div>
            <div className={classes.body}>{children}</div>
        </aside>
    );
}
